module.exports = __webpack_public_path__ + "static/media/profile_20.fb613104.jpg";